import Vue from "vue";
import Router from "vue-router";
import home from "@/components/index";
//import products from '@/components/products';
import ProductDetail from "@/components/product_detail";
import catProducts from "@/components/category-products";
import deliveryLocations from "@/components/delivery-location";
import contact from "@/components/contact-us";
import how from "@/components/how-to-buy";
import about from "@/components/about";
import termsCondition from "@/components/terms-condition";
import marketerSell from "@/components/marketer-sell";
import depositOrderList from "@/components/deposit-order-list";
import auth from "@/components/auth";
import signup from "@/components/signup";
import myProfile from "@/components/my-profile";
import myorder from "@/components/myorder";
import singleorders from "@/components/singleorder";
import depositHistory from "@/components/deposit-history";
import search from "@/components/search";
import policy from "@/components/policy";
import restaurants from "@/components/restaurants";
import myAccount from "@/components/my-account";
import deposit from "@/components/deposit";
import singleRestaurant from "@/components/singleRestaurant";
import cart from "@/components/cart";
import wishlist from "@/components/wishlist";
import gift from "@/components/gift";
import openJobs from "@/components/open-jobs";
import checkout from "@/components/checkout";
import VueSweetalert2 from "vue-sweetalert2";
import { seoFromRoute, humanize } from "@/seo";
Vue.use(VueSweetalert2);
Vue.use(Router);
const router = new Router({
  //remove #  from  url
  mode: "history",
  history: true,
  routes: [
    {
      path: "/open-jobs",
      name: "Open Jobs",
      component: openJobs,
      root: "/"
    },
    {
      path: "/gift",
      name: "Gifts",
      component: gift,
      root: "/"
    },
    {
      path: "/my-account",
      name: "My Account",
      component: myAccount,
      root: "/"
    },
    {
      path: "/delivery-locations",
      name: "Delivery Locations",
      component: deliveryLocations,
      root: "/"
    },
    {
      path: "/restaurant/:id",
      name: "Order Food",
      component: singleRestaurant,
      root: "/"
    },

    {
      path: "/deposit-history",
      name: "Deposit History",
      component: depositHistory,
      root: "/"
    },
    {
      path: "/my-deposit",
      name: "Deposit",
      component: deposit,
      root: "/"
    },
    {
      path: "/deposit-order-list",
      name: "Deposit Order List",
      component: depositOrderList,
      root: "/"
    },

    {
      path: "/restaurants",
      name: "restaurants",
      component: restaurants,
      root: "/"
    },

    {
      path: "/contact-us",
      name: "Contact Us",
      component: contact,
      root: "/"
    },
    {
      path: "/login",
      name: "Login",
      component: auth,
      root: "/"
    },
    {
      path: "/signup",
      name: "Signup",
      component: signup,
      root: "/"
    },
    {
      path: "/my-profile",
      name: "My Profile",
      component: myProfile,
      root: "/"
    },
    {
      path: "/about-us",
      name: "About Us",
      component: about,
      root: "/"
    },
    {
      path: "/terms-condition",
      name: "Terms & Condition",
      component: termsCondition,
      root: "/"
    },
    {
      path: "/how-to-buy",
      name: "How To Buy",
      component: how,
      root: "/"
    },
    {
      path: "/policy",
      name: "Privacy Policy",
      component: policy,
      root: "/"
    },
    {
      path: "/search/:param",
      name: "Product Request",
      component: search,
      root: "/"
    },
    {
      path: "/myorders",
      name: "My Orders",
      component: myorder,
      root: "/"
    },
    {
      path: "/marketer-sells/",
      name: "Marketer Sell",
      component: marketerSell,
      root: "/"
    },
    {
      path: "/myorder/:id",
      name: "singleorder",
      component: singleorders,
      root: "/"
    },
    {
      path: "/",
      name: "Online Shop in Gopalganj City",
      component: home,
      root: "/"
    },
    {
      path: "/cart",
      name: "Cart",
      component: cart,
      root: "/"
    },
    {
      path: "/wishlist",
      name: "Wishlist",
      component: wishlist,
      root: "/"
    },
    {
      path: "/checkout",
      name: "Checkout",
      component: checkout,
      root: "/"
    },
    {
      path: "/product/:slug",
      name: "Product Detail",
      component: ProductDetail,
      root: "/"
    },
    {
      path: "/:slug",
      name: "CategoryProducts",
      component: catProducts,
      root: "/"
    }
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});

const privatePage = title => ({
  title,
  description: "Manage your " + title.toLowerCase() + " at SHAH PREMIUM FOODS.",
  noindex: true
});

const seoByPath = {
  "/": {
    title: "Online Supermarket & Grocery Delivery in Île-de-France",
    description:
      "Shop fresh vegetables, fish, chicken, organic food, groceries and household essentials online at SHAH PREMIUM FOODS with fast home delivery across Île-de-France."
  },
  "/open-jobs": {
    title: "Careers & Open Jobs",
    description:
      "Explore current job openings at SHAH PREMIUM FOODS and join our growing online grocery and food delivery team."
  },
  "/gift": {
    title: "Gift Hampers & Gift Ideas",
    description:
      "Send premium gift hampers, sweets and food gifts to your loved ones with SHAH PREMIUM FOODS delivery."
  },
  "/my-account": privatePage("My Account"),
  "/delivery-locations": {
    title: "Delivery Locations & Areas",
    description:
      "Check the areas we deliver to and find out if SHAH PREMIUM FOODS delivers groceries and fresh food to your address."
  },
  "/restaurant/:id": {
    title: route => humanize(route.params.id) + " – Order Food Online",
    description: route =>
      "Order delicious food from " +
      humanize(route.params.id) +
      " online with fast delivery from SHAH PREMIUM FOODS."
  },
  "/deposit-history": privatePage("Deposit History"),
  "/my-deposit": privatePage("Deposit"),
  "/deposit-order-list": privatePage("Deposit Order List"),
  "/restaurants": {
    title: "Restaurants & Food Delivery",
    description:
      "Browse restaurants and order your favourite meals online with quick delivery from SHAH PREMIUM FOODS."
  },
  "/contact-us": {
    title: "Contact Us",
    description:
      "Get in touch with SHAH PREMIUM FOODS for order support, delivery questions, feedback or business enquiries."
  },
  "/login": {
    title: "Login",
    description:
      "Log in to your SHAH PREMIUM FOODS account to track orders, save favourites and checkout faster.",
    noindex: true
  },
  "/signup": {
    title: "Create an Account",
    description:
      "Sign up for a SHAH PREMIUM FOODS account to order groceries online, track deliveries and enjoy exclusive offers.",
    noindex: true
  },
  "/my-profile": privatePage("Profile"),
  "/about-us": {
    title: "About Us",
    description:
      "Learn about SHAH PREMIUM FOODS, your trusted online supermarket for fresh, quality groceries delivered to your door."
  },
  "/terms-condition": {
    title: "Terms & Conditions",
    description:
      "Read the terms and conditions for shopping, delivery, payment and returns at SHAH PREMIUM FOODS."
  },
  "/how-to-buy": {
    title: "How to Buy",
    description:
      "A simple step-by-step guide to ordering groceries online from SHAH PREMIUM FOODS, from choosing products to delivery."
  },
  "/policy": {
    title: "Privacy Policy",
    description:
      "Understand how SHAH PREMIUM FOODS collects, uses and protects your personal information."
  },
  "/search/:param": {
    title: route => 'Search results for "' + decodeURIComponent(route.params.param) + '"',
    description: route =>
      'Find "' +
      decodeURIComponent(route.params.param) +
      '" and more fresh groceries at SHAH PREMIUM FOODS with home delivery.',
    noindex: true
  },
  "/myorders": privatePage("Orders"),
  "/marketer-sells/": privatePage("Marketer Sales"),
  "/myorder/:id": privatePage("Order Details"),
  "/cart": {
    title: "Shopping Cart",
    description:
      "Review the items in your shopping cart and proceed to checkout at SHAH PREMIUM FOODS.",
    noindex: true
  },
  "/wishlist": {
    title: "My Wishlist",
    description:
      "Your saved products at SHAH PREMIUM FOODS. Add your favourites to the cart whenever you are ready.",
    noindex: true
  },
  "/checkout": {
    title: "Checkout",
    description:
      "Complete your grocery order securely at SHAH PREMIUM FOODS.",
    noindex: true
  },
  "/product/:slug": {
    title: route => humanize(route.params.slug),
    description: route =>
      "Buy " +
      humanize(route.params.slug) +
      " online at SHAH PREMIUM FOODS. Fresh quality, great price and fast home delivery."
  },
  "/:slug": {
    title: route => humanize(route.params.slug),
    description: route =>
      "Shop " +
      humanize(route.params.slug) +
      " online at SHAH PREMIUM FOODS. Fresh, quality products with fast home delivery."
  }
};

router.afterEach(to => {
  const matched = to.matched[0];
  seoFromRoute(to, matched && seoByPath[matched.path]);
});

export default router;

// HTACCESS CONFIGURATION
// <IfModule mod_rewrite.c>
// RewriteEngine On
// RewriteBase /
// RewriteRule ^index\.html$ - [L]
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteCond %{REQUEST_FILENAME} !-d
// RewriteRule . /index.html [L]
// </IfModule>
